import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ComputerService } from 'src/app/computer/computer.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Product, User } from 'src/typings';
import { CurrentUserService as UserService } from 'src/app/user/user.service';
import { BarcodeTypeEnum } from 'src/enums';

@Component({
  selector: 'app-print-price-tag',
  templateUrl: './print-price-tag.component.html',
  styleUrls: ['./print-price-tag.component.scss']
})
export class PrintPriceTagComponent {
  @Input() product: Product | undefined;

  user: User | undefined;

  form = this.fb.group({
    quan: new UntypedFormControl(1)
  });

  constructor(
    private readonly computerService: ComputerService,
    private readonly fb: UntypedFormBuilder,
    private readonly userService: UserService,
    private readonly notificationService: NotificationService
  ) {
    this.user = this.userService.user;
  }

  print() {
    if (!this.product) return;
    if (!this.user) return this.notificationService.warning('Не могу найти пользователя!');

    const profile = this.user.defaultLabelProfile;
    if (!profile) {
      return this.notificationService.warning('Выберите профиль этикеток в настройках.');
    }

    void this.computerService.printPriceTag({
      productId: this.product.id,
      barcodeType: BarcodeTypeEnum.CODE128,
      barcodeWidth: 3,
      barcode: this.product.id,
      price: this.product.retail,
      article: this.product.article,
      brand: this.product.brand.description,
      warehouseId: this.user?.defaultWarehouse?.id ?? null,
      cell: this.product.stock.find((wh) => wh.warehouse.id === this.user?.defaultWarehouse.id)?.cell,
      quan: Number(this.form.value.quan || 1),
      profileId: profile.profileId ?? profile.id,
      profileCode: profile.profileCode ?? profile.code ?? null,
      agentName: profile.agentName ?? null
    });
  }
}
